(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-chart-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-size-chart-open]');
    if (opener) {
      const targetId = opener.getAttribute('data-size-chart-target');
      const modal = targetId && document.getElementById(targetId);
      if (modal) {
        if (modal.parentElement !== document.body) {
          document.body.appendChild(modal);
        }
        modal.removeAttribute('hidden');
      }
      return;
    }

    const closer = event.target.closest('[data-size-chart-close]');
    if (closer) {
      const modal = closer.closest('[data-size-chart-modal]');
      if (modal) modal.setAttribute('hidden', '');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-size-chart-modal]:not([hidden])').forEach((modal) => {
      modal.setAttribute('hidden', '');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
